import type { ReactNode } from "react";
import style from "../style/components/LoadingIndicator.module.css";

export default function LoadingIndicator({ children }: { children: ReactNode }) {
    return <span className={style.inline}><span className={style.spinner} aria-hidden="true" />{children}</span>;
}
